(function(){var s=document.createElement("style");s.textContent=[".gm-size-pill:active{background:rgba(201,168,76,0.3)!important;border-color:var(--gold)!important;color:var(--gold)!important;transform:scale(0.96)!important}",".gz-mm{z-index:1002!important}",".gz-mm-bg{z-index:1001!important}",".gz-mm.open{transform:translateX(0)!important;display:flex!important;visibility:visible!important}"].join(""),document.head.appendChild(s)})(),window.gmSelectSize=function(pill){var wrap=pill.closest(".gm-size-pills");if(wrap){wrap.querySelectorAll(".gm-size-pill").forEach(function(p){p.classList.remove("active")}),pill.classList.add("active");var card=wrap.closest(".gm-card-body")||wrap.closest(".gm-card"),price=pill.dataset.price;if(card&&price){var addBtn=card.querySelector(".gm-add-btn");addBtn&&!addBtn.disabled&&addBtn.textContent.indexOf("Added")===-1&&(addBtn.textContent="Add to Order \u2014 $"+price)}}},window.addToCart=function(strainName,btn){var card=btn.closest(".gm-card-body")||btn.closest(".gm-card"),activePill=card?card.querySelector(".gm-size-pill.active"):null,variantId=activePill?activePill.dataset.id:null;if(variantId){var activePrice=activePill?activePill.dataset.price:null,originalText=activePrice?"Add to Order \u2014 $"+activePrice:"Add to Order";btn.disabled=!0,btn.textContent="Adding\u2026",fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:parseInt(variantId,10),quantity:1})}).then(function(r){if(!r.ok)throw new Error("HTTP "+r.status);return r.json()}).then(function(){btn.disabled=!1,btn.style.background="#22c55e",btn.style.color="#000",btn.textContent="\u2014 Added \u2014 View Cart \u2014",btn.onclick=function(){window.location.href="/pages/order"},typeof gmUpdateCartCount=="function"&&gmUpdateCartCount(),document.dispatchEvent(new CustomEvent("cart:added"))}).catch(function(){btn.disabled=!1,btn.style.background="",btn.style.color="",btn.textContent=originalText,btn.onclick=function(e){e.stopPropagation(),window.addToCart(strainName,btn)}})}},function(){function initPillButtons(){document.querySelectorAll(".gm-card").forEach(function(card){var activePill=card.querySelector(".gm-size-pill.active"),addBtn=card.querySelector(".gm-add-btn");activePill&&addBtn&&activePill.dataset.price&&(addBtn.textContent="Add to Order \u2014 $"+activePill.dataset.price)})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",initPillButtons):initPillButtons()}();

// Nav repair — runs after DOMContentLoaded to fix any onclick removal from old bindBtn IIFEs
(function repair(){
  function fixBtn(id, fn){
    var el = document.getElementById(id);
    if(!el) return;
    // Clone removes all event listeners added by any prior bindBtn IIFE
    var clone = el.cloneNode(true);
    clone.setAttribute('onclick', fn + '()');
    el.parentNode.replaceChild(clone, el);
  }
  function run(){
    fixBtn('gz-ham', 'gzToggleMenu');
    fixBtn('gz-mm-bg', 'gzToggleMenu');
    // Cart button uses class
    var cb = document.querySelector('.gz-cart-btn');
    if(cb){
      var cbClone = cb.cloneNode(true);
      cbClone.setAttribute('onclick', "window.location.href='/pages/order'");
      cb.parentNode.replaceChild(cbClone, cb);
    }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
// MutationObserver: force inline styles on #gz-mm — overrides stale page cache CSS
(function(){
  function applyMenuStyles(mm){
    var isOpen = mm.classList.contains('open');
    if(isOpen){
      mm.style.setProperty('transform','translateX(0)','important');
      mm.style.setProperty('display','flex','important');
      mm.style.setProperty('visibility','visible','important');
      mm.style.setProperty('pointer-events','auto','important');
    } else {
      mm.style.setProperty('transform','translateX(100%)','important');
      mm.style.setProperty('visibility','hidden','important');
      mm.style.removeProperty('display');
      mm.style.removeProperty('pointer-events');
    }
  }
  function attachObserver(){
    var mm = document.getElementById('gz-mm');
    if(!mm) return;
    applyMenuStyles(mm);
    new MutationObserver(function(){ applyMenuStyles(mm); })
      .observe(mm, {attributes:true, attributeFilter:['class']});
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
})();
// Order page: inject ship button while page cache is stale (calls real goSetFF + goUpdateShipPayBtns)
(function(){
  if(window.location.pathname !== '/pages/order') return;
  function injectShipping(){
    if(document.getElementById('go-ship-btn')) return;
    var pickBtn = document.getElementById('go-pick-btn');
    if(!pickBtn) return;
    var shipBtn = document.createElement('button');
    shipBtn.className = 'go-ff-btn';
    shipBtn.id = 'go-ship-btn';
    shipBtn.innerHTML = '📦 FL Shipping';
    shipBtn.onclick = function(){ if(typeof goSetFF==='function') goSetFF('shipping'); };
    pickBtn.parentNode.insertBefore(shipBtn, pickBtn.nextSibling);
    var grid = pickBtn.closest('.go-ff-grid');
    if(grid) grid.style.gridTemplateColumns = '1fr 1fr 1fr';
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', injectShipping);
  } else {
    injectShipping();
  }
})();

/* Pre-roll bundle badge + image normalization (gramz305.com/collections/pre-rolls) */
(function(){
  function isPrerollsPage(){
    return location.pathname.indexOf('/collections/pre-rolls') === 0
        || location.pathname.indexOf('/collections/pre-roll') === 0;
  }
  function styleOnce(id, css){
    if(document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id; s.textContent = css;
    document.head.appendChild(s);
  }
  function injectBundleBadge(){
    var cards = document.querySelectorAll('.gc-card');
    cards.forEach(function(card){
      if(card.querySelector('.gc-bundle-badge')) return;
      var tags = (card.getAttribute('data-tags')||'').toLowerCase();
      var isPreroll = tags.indexOf('pre-roll') >= 0 || tags.indexOf('preroll') >= 0
                   || (card.querySelector('a[href*="baby-jeeter"]') !== null);
      if(!isPreroll) return;
      var anchor = card.querySelector('.gc-size-pills') || card.querySelector('.gc-add-btn');
      if(!anchor) return;
      var b = document.createElement('div');
      b.className = 'gc-bundle-badge';
      b.textContent = '3 for $100 \u00b7 auto-applied at checkout';
      anchor.parentNode.insertBefore(b, anchor);
    });
  }
  function run(){
    if(!isPrerollsPage()) return;
    styleOnce('gc-bundle-css',
      '.gc-bundle-badge{display:inline-block;font-size:11px;font-weight:700;color:#1aa84e;'
      + 'background:rgba(26,168,78,0.10);border:1px solid rgba(26,168,78,0.35);'
      + 'border-radius:6px;padding:4px 8px;margin:4px 0 8px;letter-spacing:0.2px}'
      + '.gc-card-img{background:#1a1a1a!important}'
      + '.gc-card-img img{object-fit:cover!important;object-position:center!important}'
    );
    injectBundleBadge();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
// gramz-fix v1778706000
